// material-ui
import { red } from '@mui/material/colors';
import { styled } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';
import { useSelector } from 'store';
import { gridSpacing } from 'store/constant';

interface MainInnerStyleProps {
  borderRadius: number;
}

// ==============================|| MAIN LAYOUT - STYLED ||============================== //

const MainInnerContentStyled = styled('main', {
  shouldForwardProp: (prop) => prop !== 'borderRadius',
})<MainInnerStyleProps>(({ theme, borderRadius }) => {
  // הסידבארים כבר לא תופסים מקום כשהם סגורים (width: 0)
  // לכן התוכן תמיד יהיה ברוחב מלא

  return {
    backgroundColor:
      theme.palette.mode === ThemeMode.DARK ? theme.palette.dark[800] : theme.palette.grey[100],
    minWidth: '1%',
    width: '100%',
    height: '100%',
    flexGrow: 1,
    overflow: 'hidden',
    borderRadius: `${borderRadius}px`,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shorter + 200,
    }),
    // שמירה על margins קבועים בכל הגדלים
    marginLeft: 24,
    marginRight: 24,
  };
});

export default MainInnerContentStyled;
